/**
 * 渐变预设：仅包含色标数据，应用时由 store 分配稳定 `id`。
 */

/** 编辑器中的单个渐变控制点。 */
export interface GradientStop {
  id: string
  hex: string
  /** 0–100 */
  position: number
}

export interface GradientStopSeed {
  hex: string
  /** 0–100 */
  position: number
}

export interface GradientPresetDefinition {
  id: string
  /** 展示用短名（可选） */
  label?: string
  stops: readonly GradientStopSeed[]
}

export const GRADIENT_PRESET_LIST: readonly GradientPresetDefinition[] = [
  { id: 'linen-rose', stops: [
    { hex: '#fdfcfb', position: 0 },
    { hex: '#ffb7c5', position: 100 },
  ] },
  { id: 'sky-lake', stops: [
    { hex: '#dbeafe', position: 0 },
    { hex: '#22d3ee', position: 100 },
  ] },
  { id: 'violet-magenta', stops: [
    { hex: '#ede9fe', position: 0 },
    { hex: '#d946ef', position: 100 },
  ] },
  { id: 'peach-coral', stops: [
    { hex: '#ffedd5', position: 0 },
    { hex: '#fb7185', position: 100 },
  ] },
  { id: 'mint-emerald', stops: [
    { hex: '#ecfdf5', position: 0 },
    { hex: '#10b981', position: 100 },
  ] },
  { id: 'slate-charcoal', stops: [
    { hex: '#f1f5f9', position: 0 },
    { hex: '#0f172a', position: 100 },
  ] },
  { id: 'gray-triple', stops: [
    { hex: '#fdfcfb', position: 0 },
    { hex: '#9ca3af', position: 45 },
    { hex: '#374151', position: 100 },
  ] },
  { id: 'sunset', stops: [
    { hex: '#fef3c7', position: 0 },
    { hex: '#fb923c', position: 55 },
    { hex: '#7c3aed', position: 100 },
  ] },
  { id: 'ocean', stops: [
    { hex: '#e0f2fe', position: 0 },
    { hex: '#0369a1', position: 100 },
  ] },
  { id: 'forest', stops: [
    { hex: '#ecfccb', position: 0 },
    { hex: '#166534', position: 100 },
  ] },
  { id: 'lavender-night', stops: [
    { hex: '#f5f3ff', position: 0 },
    { hex: '#312e81', position: 100 },
  ] },
  { id: 'sandstone', stops: [
    { hex: '#fff7ed', position: 0 },
    { hex: '#c2410c', position: 100 },
  ] },
  { id: 'chrome', stops: [
    { hex: '#ffffff', position: 0 },
    { hex: '#d4d4d8', position: 50 },
    { hex: '#71717a', position: 100 },
  ] },
  { id: 'berry', stops: [
    { hex: '#fce7f3', position: 0 },
    { hex: '#be123c', position: 100 },
  ] },
  { id: 'ice-azure', stops: [
    { hex: '#f0f9ff', position: 0 },
    { hex: '#38bdf8', position: 100 },
  ] },
  { id: 'amber-coal', stops: [
    { hex: '#fffbeb', position: 0 },
    { hex: '#1c1917', position: 100 },
  ] },
  { id: 'rose-midnight', stops: [
    { hex: '#ffe4e6', position: 0 },
    { hex: '#4c0519', position: 100 },
  ] },
  { id: 'teal-slate', stops: [
    { hex: '#ccfbf1', position: 0 },
    { hex: '#0f766e', position: 60 },
    { hex: '#0f172a', position: 100 },
  ] },
  { id: 'studio-soft', stops: [
    { hex: '#fdfcfb', position: 0 },
    { hex: '#6b6b6b', position: 33 },
    { hex: '#ffffff', position: 67 },
    { hex: '#e8e8ea', position: 100 },
  ] },
  { id: 'aurora', stops: [
    { hex: '#dbeafe', position: 0 },
    { hex: '#a78bfa', position: 40 },
    { hex: '#f472b6', position: 100 },
  ] },
] as const
